import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes';
import {connect} from 'react-redux';
import {Keys} from '../../model/constants'
import AssLstPanel from '../components/AssLstPanel'
import * as Immutable from 'immutable';
let AssigneesPage = (props) => {
    return (
        <AssLstPanel {...props} />
    )
};

AssigneesPage.propTypes = {
    dispatch:React.PropTypes.func.isRequired,
    assignees:ImmutablePropTypes.map.isRequired,
    groups:ImmutablePropTypes.map.isRequired,
    mutations:ImmutablePropTypes.map.isRequired,
    currentWorkSession:ImmutablePropTypes.map.isRequired,
};

const mapSateToProps = (state) => {
    return {
        mutations: state.mutationsState.get(Keys.EditorIds.ASSIGNEE_PAGE, Immutable.Map()),
        assignees: state.assigneesState.get(Keys.StoreSliceData.ASSIGNEES),
        groups: state.groupsState.get(Keys.StoreSliceData.GROUPS),
        currentWorkSession: state.currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION,Immutable.Map()),
    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch:dispatch
        //doRefreshWorkSessions: () => dispatch(loadWorkSessions()),
        //doLoadWorkSession: (workSessionId) => dispatch(loadCurrentSession(workSessionId)),
        //doCreateAndLoadWorkSession: (templateId, onSuccess) => dispatch(createAndLoadNewSession(templateId, onSuccess)),
    }
};
AssigneesPage.contextTypes = {
    router:React.PropTypes.object
};

export default connect(mapSateToProps, mapDispatchToProps)(AssigneesPage);



// WEBPACK FOOTER //
// ./src/ui/pages/AssigneesPage.js